import { render, staticRenderFns } from "./group-add.vue?vue&type=template&id=7346617c&scoped=true&"
import script from "./group-add.vue?vue&type=script&lang=js&"
export * from "./group-add.vue?vue&type=script&lang=js&"
import style0 from "./group-add.vue?vue&type=style&index=0&id=7346617c&lang=less&scoped=true&"
import style1 from "./group-add.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7346617c",
  null
  
)

export default component.exports